import {useMutation} from '@tanstack/react-query';

import {postSurgeryConfirm} from '../../services/postSurgeryConfirm';

export const usePostSurgeryConfirmMutation = () => {
	return useMutation({
		mutationFn: postSurgeryConfirm,
	});
};
